import { useLocation } from "react-router-dom";
import Companion from "@/pages/Companion";

const PROMPTS = ["What should I focus on this week?", "I'm losing motivation. Help me reset.", "Give me an idea I haven't tried yet", "How am I really doing on my year?"];

export default function V2Companion() {
  const { state } = useLocation();
  return <Companion v2 endpoint="/v2/chat/stream" prompts={PROMPTS} heading="Talk to CAMRYN"
    subline="Remembers your year, your projects and what you've told it. Not a doctor." opener={state?.opener || null} />;
}
